﻿export function contains<T>(arr: T[], item: T) { return arr.indexOf(item) > -1; }
export function addRange<T>(arr: T[], range: T[]) { arr.push(...range); }
export function clear<T>(arr: T[]) {
   arr.length = 0
}
export function clone<T>(arr: T[]):T[] { return [...arr];}
export function remove<T>(arr: T[], item: T): boolean {
    const i = arr.indexOf(item);
    if (i >= 0) { arr.splice(i, 1); return true; }
    return false;
}

export function removeAll<T>(arr: T[], value: T): number;
export function removeAll<T>(arr: T[], predicate: (item: T, index: number) => boolean): number;
export function removeAll<T>(arr: T[], valueOrPredicate: T | ((item: T, index: number) => boolean)): number {
  const predicate: (item: T, index: number) => boolean = isPredicate(valueOrPredicate)
    ? valueOrPredicate
    : (item => item === valueOrPredicate);
  let removedCount = 0;
  for (let i = arr.length - 1; i >= 0; i--) {
    const item = arr[i] as T;
    if (predicate(item, i)) {
      arr.splice(i, 1);
      removedCount++;
    }
  }
  return removedCount;
}

function isPredicate<T>(arg: T | ((item: T, index: number) => boolean)): arg is (item: T, index: number) => boolean {
  return typeof arg === 'function';
}

/**
 * Executes an asynchronous function in parallel for all elements of the array.
 * @param func A function that returns a Promise for each item.
 * @param exceptUndefined Whether to exclude undefined results from the output (default: true).
 */
export async function parallelAsync<T, Q>(
  list: T[],
  func: (item: T) => Q | Promise<Q>,
  exceptUndefined: boolean = true
): Promise<Awaited<Q>[]> {
  const promises = list.map(func);
  const results = await Promise.all(promises);

  return exceptUndefined
    ? results.filter((r): r is Awaited<Q> => r !== undefined)
    : results;
}
